import { useState, useEffect } from "react";
import axios from "axios";
import Access from "./Access";
import "../../.csscode/PopUpModal.css";
import { toast } from "sonner";
import swal from "sweetalert";
import { format } from "date-fns";
import CustomLoader from "../static/CustomLoader";
import {
  MasterPage,
  MasterToolbar,
  MasterButton,
  MasterSearch,
  MasterGrid,
  MasterDialog,
  MasterConfirmDialog,
} from "../static/Masterpage";

const AccessListing = () => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };
  const [loading, setLoading] = useState(false);
  const [accessData, setAccessData] = useState([{}]);
  const [filterData, setFilterData] = useState([{}]);
  const [serach, setSerach] = useState("");
  const [selectedData, setSelectedData] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [density, setDensity] = useState("standard");
  const [showConfirm, setShowConfirm] = useState(false);

  const [addShow, setAddShow] = useState(false);
  const addHandleClose = () => {
    setShowConfirm(true);
  };
  const addHandleShow = () => setAddShow(true);

  const [editShow, setEditShow] = useState(false);
  const editHandleClose = () => {
    setShowConfirm(true);
  };

  const handleConfirmClose = () => {
    setShowConfirm(false);
    setAddShow(false);
    setEditShow(false);
  };

  const handleCancelClose = () => {
    setShowConfirm(false);
  };
  const [userData, setUserData] = useState([]);

  const columns = [
    {
      field: "user",
      headerName: "User ID",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const userOption = userData.find(
          (option) => option.value === params.value,
        );
        return userOption ? userOption.label : params.value;
      },
    },
    {
      field: "sdate",
      headerName: "Start Date",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return params.value
          ? format(new Date(params.value), "yyyy/MM/dd HH:mm:ss")
          : "";
      },
    },
    {
      field: "edate",
      headerName: "End Date",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return params.value
          ? format(new Date(params.value), "yyyy/MM/dd HH:mm:ss")
          : "";
      },
    },
    {
      field: "roleCode",
      headerName: "Role",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
  ];

  const fetchUserData = async () => {
    try {
      setLoading(true);
      axios.get(apiUrl + "user", { headers }).then((response) => {
        const userOption = response.data.map((op) => ({
          value: op.userid,
          label: op.userid,
        }));
        setUserData(userOption);
        setLoading(false);
      });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const RemoveFunction = async () => {
    if (selectedData) {
      swal({
        title: "Do you want to remove?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (confirmDelete) => {
        if (confirmDelete) {
          setLoading(true);
          try {
            await axios
              .delete(apiUrl + "access/" + selectedData[0], { headers })
              .then((response) => {
                toast.success("Record removed successfully.");
                setLoading(false);
                fetchData();
              });
          } catch (error) {
            console.error("Error deleting record:", error);
            setLoading(false);
          }
        }
      });
    } else {
      toast.warning("Please Select at least one value");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    fetchUserData();
  }, [refresh]);

  const fetchData = async () => {
    try {
      setLoading(true);
      axios
        .get(apiUrl + "access", { headers })
        .then((response) => {
          setAccessData(response.data);
          setFilterData(response.data);
          setRefresh(false);
          setSelectedData("");
          setLoading(false);
        })
        .catch((error) => {
          console.log("error " + error);
          setAccessData([{}]);
          setLoading(false);
        });
    } catch (error) {
      setAccessData([{}]);
      setLoading(false);
    }
  };

  const handlesearch = (event) => {
    const getSearch = event.target.value.toLowerCase();
    if (getSearch.length > 0) {
      const searchdata = filterData.filter((item) =>
        Object.keys(item).some((key) =>
          String(item[key]).toLowerCase().includes(getSearch),
        ),
      );
      setAccessData(searchdata);
    } else {
      setAccessData(filterData);
    }
    setSerach(getSearch);
  };

  const editHandleShow = () => {
    if (selectedData.length > 1 || selectedData.length === 0) {
      toast.warning("Please Select only one value");
      return;
    }
    setEditShow(true);
  };

  return (
    <>
      <MasterPage>
        <MasterToolbar
          actions={
            <>
              <MasterButton
                variant="add"
                tooltip="Create new Access"
                onClick={addHandleShow}
                disabled={loading}
              >
                Add
              </MasterButton>

              <MasterButton
                variant="update"
                tooltip="Edit Selected Access"
                onClick={editHandleShow}
                disabled={loading}
              >
                Update
              </MasterButton>

              <MasterButton
                variant="danger"
                tooltip="Delete Selected Access"
                onClick={RemoveFunction}
                disabled={loading}
              >
                Delete
              </MasterButton>
            </>
          }
          search={
            <MasterSearch
              tooltip="Search by All"
              value={serach}
              onChange={(e) => handlesearch(e)}
              inputRef={(input) => input && input.focus()}
            />
          }
        />

        <MasterGrid
          density={density}
          onDensityChange={(newDensityString) => setDensity(newDensityString)}
          rows={
            accessData !== null &&
            accessData.length > 0 &&
            Object.keys(accessData[0]).length !== 0 &&
            accessData
          }
          columns={columns}
          onSelectionModelChange={(itm) => setSelectedData(itm)}
        />
      </MasterPage>

      {loading && <CustomLoader />}

      <MasterDialog open={addShow} onHide={addHandleClose} title="Add Access">
        <Access
          selectedId=""
          mode="A"
          onHide={addHandleClose}
          setRefresh={setRefresh}
        />
      </MasterDialog>

      <MasterDialog
        open={editShow}
        onHide={editHandleClose}
        title="Edit Access"
      >
        <Access
          selectedId={selectedData && selectedData[0]}
          mode="U"
          onHide={editHandleClose}
          setRefresh={setRefresh}
        />
      </MasterDialog>

      <MasterConfirmDialog
        show={showConfirm}
        title="Close Confirmation"
        message="Are you sure you want to close this modal?"
        onConfirm={handleConfirmClose}
        onCancel={handleCancelClose}
      />
    </>
  );
};

export default AccessListing;
